import React from "react";
import { Card } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { updateReportSchemeState } from "../../Store";
import ReportItemEntityListRow from "../Entities/ReportItemEntityListRow";

export default function MonoSpace({ entity, children }) {
  const dispatch = useDispatch();
  const entityList = useSelector((state) => state.reportScheme.visibleReportItemEntityList);

  const deleteElement = () => {
    let newList = JSON.parse(JSON.stringify(entityList));

    newList.splice(entity.order - 1, 1);
    newList.forEach((entity, i) => {
      entity.order = i + 1;
    });
    dispatch(updateReportSchemeState({ visibleReportItemEntityList: newList }));
  };
  const CreateHtmlElement = (val) => {
    return (
      <Card>
        <Card.Body>
          <div dangerouslySetInnerHTML={{ __html: val }} />
        </Card.Body>
      </Card>
    );
  };
  return (
    <>
      <div className="report-scheme-report-item-row">
        <ReportItemEntityListRow entity={entity} itemName="Tek Bölüm" />
        {children && children}
      </div>

      {children && children}
    </>
  );
}
